import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IExportPdfBaseSettings} from "@containers/export/containers/pdf/types";

export const buildWidth = <T>({
                                  columns,
                                  baseSettings,
                                  autoSize,
                              }: {
    columns: IColumnItem<T>[],
    baseSettings: IExportPdfBaseSettings,
    autoSize: boolean
}) => {
    return columns?.map((col) => {

        if ((col?.exportStyles?.pdf?.width && baseSettings?.pageSize !== 'A4') || !!autoSize) {
            return {
                width: Number(col.exportStyles.pdf?.width ?? 40)
            }
        }
        return {
            "width": "*",
        }
    })
}